import { type LabelProps } from '@direct-frontend/components';
import { type OpenApiSchemaYmlGoodsModerationStatus } from '#shared/api/schema';
import { PRODUCT_MODERATION_STATUS_LABEL_MAP } from './constants';

export function getProductModerationStatusLabelProps(
    status: OpenApiSchemaYmlGoodsModerationStatus
): Pick<LabelProps, 'addonLeft' | 'children'> {
    return {
        addonLeft: PRODUCT_MODERATION_STATUS_LABEL_MAP[status].icon,
        children: PRODUCT_MODERATION_STATUS_LABEL_MAP[status].label,
    };
}
